import styled from 'styled-components'

import LiveSelect from 'live/components/forms/ui/select'

interface OutputProps {
    sizeField: string
    withRightBorder: boolean
}

export const Form = styled.div`
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    form {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
    }
`

export const Output = styled.div<OutputProps>`
    border-right: ${props => (props.withRightBorder ? '1px solid #eee' : 'none')};
    border-top: 1px solid #eee;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: ${props => props.sizeField};
    .contentLabel {
        font-size: 13px;
        color: ${({ theme }) => theme['gray-700']};
        padding: 8px 20px 10px 20px;

        &.text-overflow {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            line-clamp: 1;
        }
    }
`

export const OutputEdit = styled.div<OutputProps>`
    border-right: ${({ withRightBorder }) => (withRightBorder ? '1px solid #eee' : 'none')};
    border-top: 1px solid #eee;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: ${({ sizeField }) => sizeField};

    .input-form-group:focus-within {
        background: ${({ theme }) => theme['blue-200']};
        .Select-control {
            * {
                background: ${({ theme }) => theme['blue-200']} !important ;
            }
        }
    }

    .avatar-text-field {
        span {
            text-align: center;
        }
    }

    .input {
        padding: 8px 20px 10px 20px;
        margin: 0;
        border: none;
        font-size: 13px;
        box-shadow: none;
        height: auto;
        background: transparent;
    }
    textarea {
        padding: 8px 20px 10px 20px;
        margin: 0;
        margin-bottom: -5px;
        border: none;
        font-size: 13px;
        line-height: 18px;
        box-shadow: none;
        height: auto;
        background: transparent;
        height: 36px;
    }

    .avatarField {
        display: none;
    }
`

export const Label = styled.label`
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 5px;
    color: ${({ theme }) => theme['gray-800']};
    z-index: 99;
    padding: 10px 20px 0px 20px;
`

export const SaveBar = styled.div`
    padding: 10px 20px;
    background: ${({ theme }) => theme['gray-200']};
    width: 100%;
    margin-top: 0px;
    button {
        width: 80px;
        height: 32px;
        border-radius: 3px;
        margin-right: 8px;
    }

    .save {
        border: none;
        background: ${({ theme }) => theme['blue-500']};
        color: #fff;
    }
    .cancel {
        border: 1px solid;
        border-color: ${({ theme }) => theme['gray-500']};
        background: transparent;
        color: ${({ theme }) => theme['gray-800']};
        margin-left: 8px;
    }
`

export const SelectEdit = styled(LiveSelect)`
    .Select-control {
        background: transparent;
        padding: 0;
        margin: 0;
        margin-top: -8px;
        border: none;
        border-bottom: 1px solid #eee;
        font-size: 13px;
        border: none;
        box-shadow: none !important;
        background: none !important;
        padding: 8px 20px 0px 20px;

        .Select-input :focus {
            background: none;
        }
        .Select-value {
            padding: 8px 20px 10px 20px;
            background: transparent;
        }
    }
    .Select-menu-outer {
        .Select-menu {
            .Select-option {
                padding-left: 20px;
            }
        }
    }
    .Select-placeholder {
        padding: 30px 0 0 20px;
    }
`
